module.exports = "<div *ngIf=\"showSpinner\" class=\"overlay\">\n  <img src=\"assets/img/loader.gif\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-spinner/loading-spinner.component.html
// module id = 568
// module chunks = 0